import { render, staticRenderFns } from "./ProfilePasswordResetCompleted.vue?vue&type=template&id=45afdfce&scoped=true&"
import script from "./ProfilePasswordResetCompleted.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordResetCompleted.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePasswordResetCompleted.vue?vue&type=style&index=0&id=45afdfce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45afdfce",
  null
  
)

export default component.exports